import fetchApi from "../fetchApi";

export const UpdateCorporateCustomer = async (id, data) => {
  const options = {
    method: "PUT",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(data),
    redirect: "follow",
  };

  return await fetchApi(`corporate-customers/${id}`, options);
};
